export default {
    url: 'https://scusesoapp01prd.bunzlusa.com/api/v1',
    isR3App: true,
    version : "1.1.51"
}